import React, { ReactNode } from "react";

interface AuthModalProps {
  children?: ReactNode;
}

const AuthModal: React.FC<AuthModalProps> = ({ children }) => {
  return <div className="flex flex-col justify-center md:w-[500px] md:p-9 px-3 py-4 mx-2 md:min-h-[500px] bg-white shadow-lg rounded-2xl ">{children}</div>;
};

export default AuthModal;
